import { extendTheme } from "@chakra-ui/react";

export const theme = extendTheme({
  config: { initialColorMode: "dark", useSystemColorMode: false },

  semanticTokens: {
    colors: {
      // backgrounds
      appBg:     { default: "#f6f7fb", _dark: "#0e1525" },
      panel:     { default: "#ffffff", _dark: "#141c2f" },
      // make fields WHITE in light mode so they don't look navy
      panelAlt:  { default: "#ffffff", _dark: "#101826" },

      // text
      text:      { default: "#1b2430", _dark: "#e9eef7" },
      textMuted: { default: "#4f5b6b", _dark: "#8ea0b5" },

      // brand / status
      brand:     { default: "#2d7ff9", _dark: "#2d7ff9" },
      success:   { default: "#00b27a", _dark: "#00c389" },
      danger:    { default: "#d64545", _dark: "#e64848" },
      divider:   { default: "rgba(0,0,0,.08)", _dark: "rgba(255,255,255,.08)" },
      outline:   { default: "rgba(0,0,0,.12)", _dark: "rgba(255,255,255,.12)" },
      warning:   { default: "#f59e0b", _dark: "#f59e0b" }, // amber
      info:      { default: "#17a2b8", _dark: "#17a2b8" }, // teal/cyan

    },
    radii: { card: { default: "14px", _dark: "14px" } },
  },

  styles: {
    global: {
      "html, body": { bg: "appBg", color: "text" },
      "h1, h2, h3": { color: "text" },                 // <-- headings readable
    },
  },

  components: {
    Heading: { baseStyle: { color: "text", fontWeight: 800 } },

    Button: {
      baseStyle: { fontWeight: 700, borderRadius: "10px" },
      variants: {
        solid:   { bg: "brand", color: "white", _hover: { filter: "brightness(1.05)" } },
        outline: { borderColor: "outline", color: "text" },
      },
    },

    Input: {
      variants: {
        outline: {
          field: {
            bg: "panelAlt",              // white (light) / dark panel (dark)
            borderColor: "outline",
            color: "text",
            _placeholder: { color: "textMuted" },
            _focusVisible: { borderColor: "brand", boxShadow: "0 0 0 3px rgba(45,127,249,.35)" },
          },
        },
      },
      defaultProps: { variant: "outline" },
    },

    Select: {
      variants: {
        outline: {
          field: {
            bg: "panelAlt",
            borderColor: "outline",
            color: "text",
            _focusVisible: { borderColor: "brand", boxShadow: "0 0 0 3px rgba(45,127,249,.35)" },
          },
        },
      },
      defaultProps: { variant: "outline" },
    },

    Card: {
      baseStyle: {
        container: {
          bg: "panel",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: "card",
          boxShadow: "0 10px 30px rgba(0,0,0,.08)",
        },
      },
    },
  },
});

